import { IonButton, useIonLoading } from "@ionic/react"
import { Box, useMediaQuery } from "@mui/material"
import { type } from "os"
import { FC, useContext, useState } from "react"
import { MeasurementTypes } from "../../pages/Threshold/Constants"
import { DefaultState } from "../../pages/Threshold/ThresholdModel"
import { FormFields } from "../FormField/FormFields"
import * as ApiService from '../../services/ApiService'
import { ProviderContext } from "../../ApplicationState"
import { useTranslations } from "../../hooks/useTranslations"

var _ = require('lodash');

export type DefaultThresholdProps = {
    defaultValues: DefaultState
    fieldDisabled: boolean
    inputChange: boolean
    measurement: any[]
    userState: any
    providerData: any
    global: boolean
    handleDefaultChange: (prop: keyof DefaultState) => (event: React.ChangeEvent<HTMLInputElement>) => void
    handleDefaultEditFields: () => void
    setFieldDisabled: React.Dispatch<React.SetStateAction<boolean>>
    user?: any
}

export const DefaultThreshold: FC<DefaultThresholdProps> = ({
    defaultValues,
    fieldDisabled,
    inputChange,
    measurement,
    handleDefaultChange,
    handleDefaultEditFields,
    setFieldDisabled,
    userState,
    providerData,
    global,
    user
}) => {
    const [showLoading, setShowLoading] = useState(true);
    const { providerState } = useContext(ProviderContext)
    const [present, dismiss] = useIonLoading();
    const desktop = useMediaQuery('(min-width:600px)');
    const labels = useTranslations()

    const handleDefaultSaveFields = () => {

        if (checkFields()) {
            alert('You have one or more threshold min value greater than max value')
            return
        }

        if (!inputChange) {
            return
        }

        // if (emptyFields()) {
        //     alert('You have left one or more field empty. Please enter a value.')
        //     return
        // }

        present({
            message: 'updating values...',
        })

        // Update thresholdValue if empty
        measurement.forEach(item => {
            if (item.thresholdValue === "") {
                item.thresholdValue = 0;
            }
        });

        const data = { ...providerData, thresholds: measurement }

        if (global) {
            const response = ApiService.updateThresholds(userState.authenticatedUser, data).then((res) => {
                setFieldDisabled(true)
                dismiss()
                alert('Success. Thresholds values updated.')
            }).catch((error) => {
                dismiss()
                alert('Oops something went wrong. Please try again.')
                console.log('error updating threshold values', error)
            })
        } else {
            const thresholdvalues = _.map(data?.thresholds, (res, index) => {
                //if (res?.providerCode !== providerState.providerId) return
                const threholdname = res?.measurementTypePart.longName

                const thresholds = {
                    thresholdType: res?.thresholdType,
                    thresholdValue: res?.thresholdValue,
                    thresholdName: threholdname,

                }
                return thresholds
            })


            const uniqueThresholdValues = thresholdvalues.filter((value, index, self) => {
                return index === self.findIndex((v) => {
                    return v.thresholdName === value.thresholdName &&
                        v.thresholdType === value.thresholdType &&
                        v.thresholdValue === value.thresholdValue
                }
                );
            })


            const valueToSend = {
                email: data?.email,
                id: 1,
                userid: data?.username,
                thresholdsData: uniqueThresholdValues
            }

            const response = ApiService.updateUserThresholds(userState.authenticatedUser, [valueToSend], providerState.providerId).then((res) => {
                dismiss()
                alert('Success. Thresholds values updated.')
            }).catch((error) => {
                dismiss()
                alert('Oops something went wrong. Please try again.')
                console.log('error updating threshold values', error)
            })
        }
    }

    const emptyFields = () => {
        const empty = _.isEmpty(defaultValues.bloodPressureSystolicMin) && _.isEmpty(defaultValues.bloodPressureSystolicMax) &&
            _.isEmpty(defaultValues.bloodPressureDiastolicMin) && _.isEmpty(defaultValues.bloodPressureDiastolicMax) &&
            _.isEmpty(defaultValues.bloodGlucoseMin) && _.isEmpty(defaultValues.bloodGlucoseMax) &&
            _.isEmpty(defaultValues.pulseMin) && _.isEmpty(defaultValues.pulseMax) &&
            _.isEmpty(defaultValues.temperatureMin) && _.isEmpty(defaultValues.temperatureMax) &&
            _.isEmpty(defaultValues.weightMin) && _.isEmpty(defaultValues.weightMax) &&
            _.isEmpty(defaultValues.bloodSaturation)

        return empty
    }

    const checkFields = () => {

        const systolicMax = Number(defaultValues.bloodPressureSystolicMax) || 0;
        const systolicMin = Number(defaultValues.bloodPressureSystolicMin) || 0;

        const diastolicMax = Number(defaultValues.bloodPressureDiastolicMax) || 0;
        const diastolicMin = Number(defaultValues.bloodPressureDiastolicMin) || 0;

        const glucoseMax = Number(defaultValues.bloodGlucoseMax) || 0;
        const glucoseMin = Number(defaultValues.bloodGlucoseMin) || 0;

        const pulseMax = Number(defaultValues.pulseMax) || 0;
        const pulseMin = Number(defaultValues.pulseMin) || 0;

        const temperatureMax = Number(defaultValues.temperatureMax) || 0;
        const temperatureMin = Number(defaultValues.temperatureMin) || 0;

        const weightMax = Number(defaultValues.weightMax) || 0;
        const weightMin = Number(defaultValues.weightMin) || 0;

        const systolic = systolicMax !== 0 && systolicMin !== 0 && systolicMax < systolicMin;
        const diastolic = diastolicMax !== 0 && diastolicMin !== 0 && diastolicMax < diastolicMin;
        const glucose = glucoseMax !== 0 && glucoseMin !== 0 && glucoseMax < glucoseMin;
        const pulse = pulseMax !== 0 && pulseMin !== 0 && pulseMax < pulseMin;
        const temperature = temperatureMax !== 0 && temperatureMin !== 0 && temperatureMax < temperatureMin;
        const weight = weightMax !== 0 && weightMin !== 0 && weightMax < weightMin;

        return systolic || diastolic || glucose || pulse || temperature || weight;

    }

    return (
        <>

            <Box sx={{ boxShadow: 3, display: 'flex', flexDirection: 'column', m: 2 }} >
                <div style={{ marginLeft: 10 }}>
                    <IonButton size="default" color="primary" onClick={handleDefaultEditFields}>{labels.Edit}</IonButton>
                    <IonButton size="default" color="primary" onClick={handleDefaultSaveFields}>{labels.SAVE}</IonButton>
                </div>
                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', margin: 10 }}>
                    <FormFields
                        style={{ m: 2, width: global ? '30ch' : '25ch' }}
                        label={labels.BloodPressureSystolic}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.BloodPressureSystolicMin}
                        value={defaultValues.bloodPressureSystolicMin == '0' ? '' : defaultValues.bloodPressureSystolicMin}
                        adornment={'mmhg'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodPressureSystolicMin)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                    <FormFields
                        style={{ m: 2, width: global ? '30ch' : '25ch' }}
                        label={''}
                        prompt={`max (>= ${labels.value})`}
                        id={MeasurementTypes.BloodPressureSystolicMax}
                        value={defaultValues.bloodPressureSystolicMax == '0' ? '' : defaultValues.bloodPressureSystolicMax}
                        adornment={'mmhg'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodPressureSystolicMax)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                </div>

                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', margin: 10 }}>
                    <FormFields
                        style={{ m: 2, width: global ? '30ch' : '25ch' }}
                        label={labels.BloodPressureDiastolic}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.BloodPressureDiastolicMin}
                        value={defaultValues.bloodPressureDiastolicMin == '0' ? '' : defaultValues.bloodPressureDiastolicMin}
                        adornment={'mmhg'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodPressureDiastolicMin)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                    <FormFields
                        style={{ m: 2, width: global ? '30ch' : '25ch' }}
                        label={''}
                        prompt={`max (>= ${labels.value})`}
                        id={MeasurementTypes.BloodPressureDiastolicMax}
                        value={defaultValues.bloodPressureDiastolicMax == '0' ? '' : defaultValues.bloodPressureDiastolicMax}
                        adornment={'mmhg'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodPressureDiastolicMax)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>
                </div>

                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', marginLeft: 10 }}>
                    <FormFields
                        style={{ ml: { md: 11, xs: 2 }, width: global ? '30ch' : '25ch' }}
                        label={labels.BloodGlucose}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.BloodGlucoseMin}
                        value={defaultValues.bloodGlucoseMin == '0' ? '' : defaultValues.bloodGlucoseMin}
                        adornment={'mg/dl'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodGlucoseMin)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                    <FormFields
                        style={{ ml: { md: 4, xs: 2 }, width: global ? '30ch' : '25ch' }}
                        label={''}
                        prompt={`max (>= ${labels.value})`}
                        id={MeasurementTypes.BloodGlucoseMax}
                        value={defaultValues.bloodGlucoseMax == '0' ? '' : defaultValues.bloodGlucoseMax}
                        adornment={'mg/dl'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodGlucoseMax)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>
                </div>

                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', marginTop: 30, marginLeft: 10 }}>

                    <FormFields
                        style={{ ml: { md: 19, xs: 2 }, width: global ? '30ch' : '25ch' }}
                        label={labels.Pulse}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.PulseMin}
                        value={defaultValues.pulseMin == '0' ? '' : defaultValues.pulseMin}
                        adornment={'bpm'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.PulseMin)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                    <FormFields
                        style={{ ml: { md: 4, xs: 1 }, width: global ? '30ch' : '25ch' }}
                        label={''}
                        prompt={`max (>= ${labels.value})`}
                        id={MeasurementTypes.PulseMax}
                        value={defaultValues.pulseMax == '0' ? '' : defaultValues.pulseMax}
                        adornment={'bpm'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.PulseMax)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>
                </div>


                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', marginLeft: 10, marginTop: 30 }}>
                    <FormFields
                        style={{ ml: { md: 12.5, xs: 2 }, width: global ? '30ch' : '25ch' }}
                        label={labels.Temperature}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.TemperatureMin}
                        value={defaultValues.temperatureMin == '0' ? '' : defaultValues.temperatureMin}
                        adornment={'F'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.TemperatureMin)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                    <FormFields
                        style={{ ml: 4, width: global ? '30ch' : '25ch' }}
                        label={''}
                        prompt={`max (>= ${labels.value})`}
                        id={MeasurementTypes.TemperatureMax}
                        value={defaultValues.temperatureMax == '0' ? '' : defaultValues.temperatureMax}
                        adornment={'F'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.TemperatureMax)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>
                </div>

                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', marginLeft: 10, marginTop: 30 }}>

                    <FormFields
                        style={{ ml: { md: 18, xs: 2 }, width: global ? '30ch' : '25ch' }}
                        label={labels.Weight}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.WeightMin}
                        value={defaultValues.weightMin == '0' ? '' : defaultValues.weightMin}
                        adornment={'lbs'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.WeightMin)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>

                    <FormFields
                        style={{ ml: 4, width: global ? '30ch' : '25ch' }}
                        label={''}
                        prompt={`max (>= ${labels.value})`}
                        id={MeasurementTypes.WeightMax}
                        value={defaultValues.weightMax == '0' ? '' : defaultValues.weightMax}
                        adornment={'lbs'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.WeightMax)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>
                </div>

                <div style={{ display: 'flex', flexDirection: desktop ? 'row' : 'column', alignItems: 'baseline', marginLeft: 10, marginTop: 30, marginBottom: 5 }}>
                    <FormFields
                        style={{ ml: { md: 9, xs: 2 }, width: global ? '30ch' : '25ch' }}
                        label={labels.OxygenSaturation}
                        prompt={`min (<= ${labels.value})`}
                        id={MeasurementTypes.BloodSaturation}
                        value={defaultValues.bloodSaturation == '0' ? '' : defaultValues.bloodSaturation}
                        adornment={'%'}
                        handleFormValueChange={handleDefaultChange(MeasurementTypes.BloodSaturation)}
                        disabled={fieldDisabled}
                    >
                    </FormFields>
                </div>

            </Box>
        </>
    )
}